import React from "react";
import { Button, Form } from "react-bootstrap";
import { DatePicker } from "antd";
import moment from "moment";

class ServiceConfirmationModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            estimatedDate:
                (this.props.serviceConfirmation && this.props.serviceConfirmation.estimatedDate)
                    ? this.props.serviceConfirmation.estimatedDate : null,
            confirmation: this.props.serviceConfirmation === null
                || (this.props.serviceConfirmation !== null
                    && this.props.serviceConfirmation.estimatedDate)
                ? "withDate" : "withoutDate",
            error: null
        };
        this.dateFormat = "YYYY-MM-DD";
    }

    handleChange = (e) => {
        this.setState({
            [e.currentTarget.name]: e.currentTarget.value,
            error: null
        });
    };

    handleDateChange = (date, dateString) => {
        this.setState({
            estimatedDate: dateString,
            error: null
        });
    };

    handleSave = (e) => {
        e.preventDefault();
        if (this.state.confirmation === "withDate") {
            if (this.state.estimatedDate) {
                this.props.handleSave(this.state.estimatedDate);
            } else {
                this.setState({
                    error: "Date field is required"
                });
            }
        } else if (this.state.confirmation === "withoutDate") {
            this.props.handleSave(null);
        }
    };

    render() {
        const { serviceConfirmation } = this.props;
        const { estimatedDate, confirmation, error } = this.state;
        const { earliestDate, latestDate } = this.props.original;
        return (
            <div className="p-2">
                <Form id={`service-confirmation-form=${this.props.original.serviceId}`} className="mb-3">
                    <div className="mb-2 form-check">
                        <input
                            name="confirmation"
                            type="radio"
                            id="withDate"
                            className="form-check-input g-pointer"
                            value="withDate"
                            checked={confirmation === "withDate"}
                            onChange={this.handleChange} />
                        <label htmlFor="withDate" className="form-check-label g-pointer">
                            I confirm that the service will be completed on this day
                        </label>
                    </div>

                    {confirmation === "withDate" &&
                    <div className="mb-3">
                        <DatePicker
                            className="mb-1"
                            onChange={this.handleDateChange}
                            Format={this.dateFormat}
                            value={estimatedDate ? moment(estimatedDate) : null}
                            name="date"
                            required
                            disabledDate={d => !d
                                || d.isBefore(moment(earliestDate).format("YYYY-MM-DD"), "day")
                                || d.isAfter(moment(latestDate).format("YYYY-MM-DD"), "day")}
                            placeholder="Select the Date"
                        />
                        <span className="text-danger d-block">{error}</span>
                    </div>
                    }

                    <div className="form-check">
                        <input
                            name="confirmation"
                            type="radio"
                            id="withoutDate"
                            className="form-check-input g-pointer"
                            value="withoutDate"
                            checked={confirmation === "withoutDate"}
                            onChange={this.handleChange} />
                        <label for="withoutDate" className="form-check-label g-pointer">
                            I confirm the service but not sure about the Date
                        </label>
                    </div>
                </Form>

                <div className="d-flex justify-content-between mt-4">
                    <div>
                        {serviceConfirmation ?
                        <Button variant="danger" className="mr-2" onClick={this.props.handleDelete}>
                            Delete Confirmation
                        </Button>
                        : null}
                    </div>
                    <div>
                        <Button variant="secondary" className="mr-2" onClick={this.props.handleCancel}>Cancel</Button>
                        <Button variant="success" className="mr-2" onClick={this.handleSave}>Save</Button>
                    </div>
                </div>

            </div>
        );
    }
}

export default ServiceConfirmationModal;
